import Box from '@mui/joy/Box'
import Card from '@mui/joy/Card'
import CardActions from '@mui/joy/CardActions'
import CardContent from '@mui/joy/CardContent'
import Divider from '@mui/joy/Divider'
import Typography from '@mui/joy/Typography'
import Button from '@mui/joy/Button'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import { BillingAPI } from '../api/BillingAPI'

export const Billing = ({ data }) => {
    const handleClick = () => {
        BillingAPI.createManageUrl().then((response) => {
            window.location.href = response.data.url
        })
    }

    return (
        <Card
            variant="outlined"
            sx={{
                maxHeight: 'max-content',
                maxWidth: '100%',
                width: '50%',
                overflow: 'auto',
            }}
        >
            <Typography level="title-lg" startDecorator={<CreditCardIcon />}>
                Billing
            </Typography>
            <Divider inset="none" />
            <CardContent
                sx={{
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}
                >
                    <Box>
                        <b>Name:</b> {data.product_name}
                    </Box>
                    <Box>
                        <b>Billing Cycle:</b> {data.plan_interval}
                    </Box>
                    <Box>
                        <b>Subscription Status:</b> {data.status}
                    </Box>
                    {data.status === 'trailing' && (
                        <>
                            <Box>
                                <b>Trial Start:</b> {data.trial_start}
                            </Box>
                            <Box>
                                <b>Trial End:</b> {data.trail_end}
                            </Box>
                        </>
                    )}
                </Box>
                <CardActions>
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Button
                            variant="soft"
                            color="primary"
                            onClick={handleClick}
                        >
                            Manage
                        </Button>
                    </Box>
                </CardActions>
            </CardContent>
        </Card>
    )
}
